/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubmitAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function SubmitAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/SubmitAction",
  isSubmitting
  
}) {
let tabSchedulingValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'scheduling',
})
let appointmentOverlayValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
})
let aggregateData = fromHelpers.isDisabled(tabSchedulingValueData, appointmentOverlayValueData)
let appointmentOverlayIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'appointment_overlay',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="primary"
 size="small"
 disabled={aggregateData ? true : appointmentOverlayIsSubmittingData ? true : false}
 text="Schedule"
 onClick={onClick}
 data={aggregateData ? "appointment_overlay" : "tab.scheduling"}
 data={aggregateData ? "appointment_overlay" : "appointment_overlay"}
 aggregate="helpers.js isDisabled"
/>
{children}
</React.Fragment>)
}